import { createFileRoute } from "@tanstack/react-router";

import { MorrowMemoryPage } from "../components/memory/MorrowMemoryPage";

type MemorySearch = {
  node?: string | undefined;
};

export const Route = createFileRoute("/memory")({
  component: MorrowMemoryPage,
  validateSearch: (search: Record<string, unknown>): MemorySearch => {
    const node =
      typeof search.node === "string" && search.node.trim() ? search.node.trim() : undefined;
    return node ? { node } : {};
  },
});
